import React, { useState } from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBodyText, FDBox, FDHeadlineText, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('GuidedHouseholdReviewOutroLayout', (theme) => ({
  root: {
    position: 'relative',
    width: '80%',
    maxWidth: '1000px',
    margin: '0 auto',
  },
  content: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    // Vertically center the content
    display: 'flex',
    alignItems: 'center',
    // For this image, this allows the content to avoid colliding with the image
    paddingLeft: '20%',
    paddingRight: '20%',
    // Because this image is blue and FD doesn't know about it, we need to make the text white.
    // It might seem like a better solution would be to have an emphasis background behind this, but this image comes with translucent padding that would actually fuck up the emphasized background!
    '& .FD-MuiTypography-root': {
      color: theme.palette.common.white,
    },
  },
}));
export const GuidedHouseholdReviewOutroLayout = () => {
  const { resource, saving, onSubmit } = useMetaLayoutContext();
  const [imgLoaded, setImgLoaded] = useState(false);
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img
        src={resource.relationship(fr.relationships.image.name).link('related').url()}
        alt=""
        onLoad={() => setImgLoaded(true)}
      />
      {imgLoaded ? (
        <div className={classes.content}>
          <FDBox padding={8}>
            <FDStack direction={'column'} spacing={3} justifyContent={'center'} alignItems={'center'}>
              <FDHeadlineText
                color="textPrimary"
                value={resource.attr('headline')}
              />
              <FDStack direction={'column'} spacing={3} justifyContent={'center'} alignItems={'center'}>
                <FDBodyText value={resource.attr('description')} align={'center'} />
                <FDPrimaryActionButton
                  {...dataAttrs('submit-btn')}
                  loading={saving}
                  onClick={onSubmit}
                  label={resource.attr('primaryActionLabel') || 'Submit'}
                  icon="arrowRight"
                  iconPosition="end"
                  size="lg"
                />
              </FDStack>
            </FDStack>
          </FDBox>
        </div>
      ) : null}
    </div>
  );
};
